import { IPlayerRootReducerShape } from '../rootPlayerStore';

export const visibleAskToResumeOverlaySelector = (
  state: IPlayerRootReducerShape
) => state.askToResumeOnVisitOverlay.visibleAskToResumeOverlay;
